import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when clicking outside or on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: 'https://kmconsultingtech.co.uk/'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0B1426]/95 backdrop-blur-xl border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="flex items-center justify-between" data-id="element-173">
          {/* Logo */}
          <a href="#" className="flex items-center group z-10" data-id="element-174">
            <img src="https://cdn.magicpatterns.com/uploads/qwbAJXKtFBS58G1ixVPKhL/cropped-KM-CONSULTING.png" alt="KM Consulting - Web Design & Digital Marketing" className="h-10 md:h-12 w-auto group-hover:opacity-90 transition-opacity" data-id="element-175" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-176">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-[#d8a43e] transition-colors relative group" data-id="element-177">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#d8a43e] transition-all group-hover:w-full" data-id="element-178" />
              </a>)}
            <a href="https://wa.me/447412843259?text=Hi%2C%20I%27d%20like%20a%20free%20consultation%20with%20KM%20Consulting" target="_blank" rel="noopener noreferrer" data-id="element-179">
              <Button variant="primary" size="sm" className="font-mono text-xs" data-id="element-180">
                Free Consultation
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-300 hover:text-white z-10 relative" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMobileMenuOpen} data-id="element-181">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-182" /> : <Menu className="w-6 h-6" data-id="element-183" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-184">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.2
      }} className="md:hidden absolute top-full left-0 right-0 bg-[#0B1426]/98 backdrop-blur-xl border-t border-white/10 shadow-2xl" data-id="element-185">
            <div className="px-4 py-6 space-y-1" data-id="element-186">
              {navLinks.map((link, index) => <motion.a key={link.name} href={link.href} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.05
          }} className="block py-3 px-4 text-lg font-medium text-gray-300 hover:text-[#d8a43e] hover:bg-white/5 rounded-lg transition-colors" onClick={handleLinkClick} data-id="element-187">
                  {link.name}
                </motion.a>)}
              <div className="pt-4 px-4" data-id="element-188">
                <a href="https://wa.me/447412843259?text=Hi%2C%20I%27d%20like%20a%20free%20consultation%20with%20KM%20Consulting" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick} data-id="element-189">
                  <Button className="w-full" data-id="element-190">Free Consultation</Button>
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}